/* tslint:disable */

/**
 */
export class VehicleSearch {
    license?: string;
    active?: boolean;
}
